<ng-container *ngIf="isInDevEnvironment">
  <div class="row">
    <div class="col-2">
      <div class="sticky-top nav-bar">
        <h4>Estilos</h4>
        <ul class="nav flex-column">
          <li class="nav-item">
            <a class="nav-link" (click)="scrollTo('textos')">Texto</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" (click)="scrollTo('titulos')">Títulos</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" (click)="scrollTo('cabeceras')">Cabeceras</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" (click)="scrollTo('botones')">Botones</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" (click)="scrollTo('cards')">Cards</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" (click)="scrollTo('carrusel')">Carrrusel</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" (click)="scrollTo('accordion')">Accordion</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="col-10">
      <div class="section_header">
        <div class="section_header_title">
          <h1>Estilos STIHL</h1>
        </div>
        <div class="section_header_description">
          <p class="lead">Esto pretende ser un listado no exhaustivo de los estilos personalizados de la plataforma. Utilizamos Bootstrap 5 como base para las hojas de estilo de la plataforma, esto quiere decir que todos los estilos de Bootstrap 5 están disponibles. Para más información visita la <a href="https://getbootstrap.com/docs/5.2/getting-started/introduction/" target="_blank">documentación de Bootstrap</a></p>
        </div>

        <div class="alert alert-primary alert-withicon" role="alert">
          <div class="alert-icon">
            <fa-icon [icon]="['fas','circle-exclamation']"></fa-icon>
          </div>
          <div class="alert-text">Es importante <strong>no sobrescribir en la medida de lo posibles las clases de Bootstrap</strong> al aplicar estilos. Sobre todo es imprescindible no modificar su utilidad. Si necesitamos modificar alguna propiedad de estas, la forma correcta de hacerlo es a través de sus <strong>variables</strong>.</div>
        </div>
      </div>

      <div id="textos" class="patterns-section">
        <h2 class="patterns-section-title">Textos</h2>
        <div class="patterns-subsection">
          <h1>h1. STIHL heading</h1>
          <h2>h2. STIHL heading</h2>
          <h3>h3. STIHL heading</h3>
          <h4>h4. STIHL heading</h4>
          <h5>h5. STIHL heading</h5>
          <h6>h6. STIHL heading</h6>

          <div class="patterns-code">
            <div>&lt;h1&gt;h1. STIHL heading&lt;/h1&gt;</div>
            <div>&lt;h2&gt;h2. STIHL heading&lt;/h2&gt;</div>
            <div>&lt;h3&gt;h3. STIHL heading&lt;/h3&gt;</div>
            <div>&lt;h4&gt;h4. STIHL heading&lt;/h4&gt;</div>
            <div>&lt;h5&gt;h5. STIHL heading&lt;/h5&gt;</div>
            <div>&lt;h6&gt;h6. STIHL heading&lt;/h6&gt;</div>
          </div>
        </div>
        <div class="patterns-subsection">
          <h1 class="txt_bar">h1. STIHL heading</h1>
          <h2 class="txt_bar">h2. STIHL heading</h2>

          <div class="patterns-code">
            <div>&lt;h1 class="txt_bar"&gt;h1. STIHL heading&lt;/h1&gt;</div>
            <div>&lt;h2 class="txt_bar"&gt;h2. STIHL heading&lt;/h2&gt;</div>
          </div>
        </div>
        <div class="patterns-subsection">
          <p>Este es un parrafo normal. Lorem ipsum dolor sit amet consectetur adipisicing elit. Neque hic mollitia officiis porro dolores, ad dolor quisquam dolore modi expedita impedit dicta sunt inventore quasi? Repellendus libero in facilis necessitatibus.</p>
          <p class="lead">Este es un parrafo descatado. Sobresale sobre el resto de parrafos. Lorem ipsum dolor sit amet consectetur adipisicing elit. Provident autem ullam numquam et distinctio consequatur totam enim. Deleniti ratione est sed sequi quisquam eaque officiis, debitis fuga nobis rerum natus.</p>
          <p><small>Este es un parrafo para letra pequeña. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Cupiditate beatae quia atque ratione adipisci. Deserunt recusandae vitae, autem quibusdam veritatis expedita asperiores veniam deleniti aut suscipit ea vero itaque voluptatem?</small></p>
          <p><strong>Este es un parrafo en negrita. Lorem ipsum dolor sit amet consectetur, adipisicing elit. Perspiciatis, reiciendis. Porro reprehenderit ad quos? Ducimus possimus, error incidunt temporibus odit quo! Voluptatem distinctio dolorem accusamus illum sit qui doloribus ratione.</strong></p>
          <p><em>Este es un parrafo en itálica. Lorem, ipsum dolor sit amet consectetur adipisicing elit. Voluptates aperiam sit laudantium optio, ipsam sunt molestiae rerum ipsum nobis quasi accusamus nisi incidunt, voluptatibus nulla ullam at minus minima itaque?</em></p>
          <p class="text-center">Un parrafo alineado al centro. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Cumque dolor quis corrupti odio neque, error maiores voluptate est soluta ducimus ea dicta, nihil adipisci. Voluptatem illum similique rerum neque velit?</p>
          <p class="text-end">Un parrafo alinedo a la derecha. Lorem ipsum dolor sit amet consectetur adipisicing elit. Impedit error quibusdam magni? Voluptatibus corrupti ab nostrum saepe fugiat laudantium, nisi labore possimus veniam porro ipsa recusandae quis, iste mollitia exercitationem!</p>
          <p id="plinks">Diferentes enlaces. <a href="#" (click)="scrollTo('plinks')" class="plain-link">Lorem ipsum</a> dolor sit amet consectetur <a href="#" (click)="scrollTo('plinks')">adipisicing elit</a>. Impedit error quibusdam magni? Voluptatibus corrupti ab nostrum saepe <a href="#" (click)="scrollTo('plinks')" class="highlighted-link">fugiat laudantium</a>, nisi labore possimus veniam porro ipsa recusandae quis, iste mollitia exercitationem!</p>

          <div class="patterns-code">
            <div>&lt;p&gt;Este es un parrafo normal.&lt;/p&gt;</div>
            <div>&lt;p class="lead"&gt;Este es un parrafo descatado. Sobresale sobre el resto de parrafos.&lt;/p&gt;</div>
            <div>&lt;p&gt;&lt;small&gt;Este es un parrafo para letra pequeña.&lt;/small&gt;&lt;/p&gt;</div>
            <div>&lt;p&gt;&lt;strong&gt;Este es un parrafo en negrita.&lt;/strong&gt;&lt;/p&gt;</div>
            <div>&lt;p&gt;&lt;em&gt;Este es un parrafo en itálica.&lt;/em&gt;&lt;/p&gt;</div>
            <div>&lt;p class="text-center"&gt;Un parrafo alineado al centro.&lt;/p&gt;</div>
            <div>&lt;p class="text-end"&gt;Un parrafo alinedo a la derecha.&lt;/p&gt;</div>
            <div>&lt;p class="text-end"&gt;Diferentes enlaces. &lt;a href="#"&gt;adipisicing elit&lt;/a&gt; - &lt;a href="#" class="highlighted-link"&gt;fugiat laudantium&lt;/a&gt; - &lt;a href="#" class="plain-link"&gt;nisi labore possimus&lt;/a&gt;&lt;/p&gt;</div>
          </div>
        </div>
      </div>


      <div id="titulos" class="patterns-section">
        <h2 class="patterns-section-title">Títulos</h2>
        <div class="patterns-subsection">

          <div class="section_header">
            <div class="section_header_title">
              <h2>Título de sección</h2>
              <div class="section_header_buttons"><a class="btn-orange" href="#">Botón</a> <a class="btn-back" href="#"><fa-icon [icon]="['fas','chevron-left']"></fa-icon> Voltar</a></div>
            </div>
            <div class="section_header_description">
              <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam bibendum leo quis euismod cursus. Quisque eget augue blandit, interdum leo eget, tempor metus. Sed.</p>
            </div>
          </div>

          <div class="patterns-code">
            <div>&lt;div class="section_header"&gt;</div>
            <div>&#160; &lt;div class="section_header_title"&gt;</div>
            <div>&#160; &#160; &lt;h2&gt;Título de sección&lt;/h2&gt;</div>
            <div>&#160; &#160; &lt;div class="section_header_buttons"&gt;</div>
            <div>&#160; &#160; &#160; &lt;a class="btn-orange" href="#"&gt;Botón&lt;/a&gt;</div>
            <div>&#160; &#160; &#160; &lt;a class="btn-back" href="#"&gt;&lt;fa-icon [icon]="['fas','chevron-left']"&gt;&lt;/fa-icon&gt; Voltar&lt;/a&gt;</div>
            <div>&#160; &#160; &lt;/div&gt;</div>
            <div>&#160; &lt;/div&gt;</div>
            <div>&#160; &lt;div class="section_header_description"&gt;</div>
            <div>&#160; &#160; &lt;p&gt;Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam bibendum leo quis euismod cursus.&lt;/p&gt;</div>
            <div>&#160; &lt;/div&gt;</div>
            <div>&lt;/div&gt;</div>
          </div>

        </div>
        <div class="patterns-subsection">

          <div class="section_header">
            <div class="section_header_title">
              <h2>Título de sección con alerta</h2>
              <div class="section_header_buttons"><a class="btn-orange" href="#">Botón</a> <a class="btn-back" href="#"><fa-icon [icon]="['fas','chevron-left']"></fa-icon> Voltar</a></div>
            </div>
            <div class="section_header_description">
              <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam bibendum leo quis euismod cursus. Quisque eget augue blandit, interdum leo eget, tempor metus. Sed.</p>
            </div>

            <div class="alert alert-primary alert-withicon" role="alert">
              <div class="alert-icon">
                <fa-icon [icon]="['fas','circle-exclamation']"></fa-icon>
              </div>
              <div class="alert-text">
                Lorem ipsum dolor sit amet, officia excepteur ex fugiat reprehenderit enim labore culpa sint ad nisi Lorem pariatur mollit ex esse exercitation amet. Nisi
                animcupidatat excepteur officia. Reprehenderit nostrud nostrud ipsum Lorem est aliquip amet voluptate voluptate dolor minim nulla est proident.
              </div>
            </div>
          </div>

          <div class="patterns-code">
            <div>&lt;div class="section_header"&gt;</div>
            <div>&#160; &lt;div class="section_header_title"&gt;</div>
            <div>&#160; &#160; &lt;h2&gt;Título de sección con alerta&lt;/h2&gt;</div>
            <div>&#160; &#160; &lt;div class="section_header_buttons"&gt;</div>
            <div>&#160; &#160; &#160; &lt;a class="btn-orange" href="#"&gt;Botón&lt;/a&gt;</div>
            <div>&#160; &#160; &#160; &lt;a class="btn-back" href="#"&gt;&lt;fa-icon [icon]="['fas','chevron-left']"&gt;&lt;/fa-icon&gt; Voltar&lt;/a&gt;</div>
            <div>&#160; &#160; &lt;/div&gt;</div>
            <div>&#160; &lt;/div&gt;</div>
            <div>&#160; &lt;div class="section_header_description"&gt;</div>
            <div>&#160; &#160; &lt;p&gt;Reprehenderit nostrud nostrud ipsum Lorem est aliquip amet voluptate voluptate dolor minim nulla est proident.&lt;/p&gt;</div>
            <div>&#160; &lt;/div&gt;</div>
            <div>&lt;/div&gt;</div>
            <div>&lt;div class="alert alert-primary alert-withicon" role="alert"&gt;</div>
            <div>&#160;&lt;div class="alert-icon"&gt;</div>
            <div>&#160; &#160;&lt;fa-icon [icon]="['fas','circle-exclamation']"&gt;&lt;/fa-icon&gt;</div>
            <div>&#160;&lt;/div&gt;</div>
            <div>&#160;&lt;div class="alert-text"&gt;</div>
            <div>&#160; &#160; Lorem ipsum dolor sit amet, officia excepteur ex fugiat reprehenderit enim labore culpa sint ad nisi.</div>
            <div>&#160;&lt;/div&gt;</div>
            <div>&lt;/div&gt;</div>
          </div>

        </div>

      </div>


      <div id="cabeceras" class="patterns-section">
        <h2 class="patterns-section-title">Cabeceras</h2>
        <p>El color <strong>fondo por defecto es gris claro</strong>, el de los contenedores de media y texto puede cambiarse aplicando las clases <strong>.bg-orange</strong> y <strong>.bg-black</strong></p>
        <div class="patterns-subsection">
          <div class="media_header">
            <div class="media_header_photo">
              <img alt="Alt..." src="https://placehold.co/361x238/f1792c/FFF?text=IMG" class="img-fluid">
            </div>
            <div class="media_header_text ">
              <h3 class="txt_bar">
                Ipsum Lorem est<br>
                aliquip amet.
              </h3>
              <div>Odit nostrum reprehenderit tenetur dolorem tenetur maiores autem quas.</div>
            </div>
          </div>

          <div class="patterns-code">
            <div>&lt;div class="media_header"&gt;</div>
            <div>&#160; &lt;div class="media_header_photo"&gt;</div>
            <div>&#160; &#160; &lt;img alt="Alt..." src="..." class="img-fluid"&gt;</div>
            <div>&#160; &lt;/div&gt;</div>
            <div>&#160; &lt;div class="media_header_text"&gt;</div>
            <div>&#160; &#160; &lt;h3 class="txt_bar"&gt;...&lt;/h3&gt;</div>
            <div>&#160; &#160; &lt;div&gt;...&lt;/div&gt;</div>
            <div>&#160; &lt;/div&gt;</div>
            <div>&lt;/div&gt;</div>
          </div>

        </div>
        <div class="patterns-subsection">
          <div class="media_header">
            <div class="media_header_video bg-black">
              <video controls="" class="ratio ratio-16x9" title="50192314-efb5-477e-a778-e77a19c27b22.jfif" poster="https://blobstihlportugal.blob.core.windows.net/dev-stihl-pt-public/Video\71ee4937-a531-4450-96b7-2b6f1a4bffdb.jfif">
                <source src="https://dev-api-stihl-local-pt.azurewebsites.net/api/Video/GetRangedVideos/Video/3699a7a0-4da6-4847-bfec-c89596cffd3b.mp4?access_token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9uYW1laWRlbnRpZmllciI6ImI0ZGU5NDljLWU5YTktNDkxYy04M2JkLTY0YjMyYmM4YTFjNSIsImh0dHA6Ly9zY2hlbWFzLnhtbHNvYXAub3JnL3dzLzIwMDUvMDUvaWRlbnRpdHkvY2xhaW1zL2VtYWlsYWRkcmVzcyI6InNlcmdpby5zYW5jaGV6QGdydXBvc2ltLm5ldCIsImh0dHA6Ly9zY2hlbWFzLnhtbHNvYXAub3JnL3dzLzIwMDUvMDUvaWRlbnRpdHkvY2xhaW1zL2dpdmVubmFtZSI6IlNlcmdpbyIsImh0dHA6Ly9zY2hlbWFzLnhtbHNvYXAub3JnL3dzLzIwMDUvMDUvaWRlbnRpdHkvY2xhaW1zL3N1cm5hbWUiOiJTw6FuY2hleiIsImRlYWxlcl9vcmdfYWNjb3VudF9udW1iZXIiOiIwIiwiZGVhbGVyX29yZ19uYW1lIjoiR3J1cG8gU0lNIiwiZGVhbGVyX29yZ19pZCI6Ijk2OGY1N2I2LTA0YjMtZWIxMS04MjM2LTAwMGQzYWQ3ZWUzMSIsIm5iZiI6MTY4Nzg3NjcyMSwiZXhwIjoxNjg3ODgwMzIxLCJpc3MiOiJodHRwczovL2Rldi5zdGlobC1sb2NhbC5wdC8iLCJhdWQiOiJTdGlobCBMb2NhbCBQbHVzIn0.xeV9HwO2h_r1bgwn2sbhkOCRIF4rN_-dfgl5MU5TlN4">
              </video>
            </div>
            <div class="media_header_text bg-orange">
              <h3 class="txt_bar">
                Reprehenderit nostrud<br>
                ipsum Lorem est<br>
                aliquip amet.
              </h3>
            </div>
          </div>

          <div class="patterns-code">
            <div>&lt;div class="media_header"&gt;</div>
            <div>&#160; &lt;div class="media_header_video bg-black"&gt;</div>
            <div>&#160; &#160; &lt;video controls="" class="ratio ratio-16x9" title="..." poster="..."&gt;</div>
            <div>&#160; &#160; &#160; &lt;source src="..."&gt;</div>
            <div>&#160; &#160; &lt;/video&gt;</div>
            <div>&#160; &lt;/div&gt;</div>
            <div>&#160; &lt;div class="media_header_text bg-orange"&gt;</div>
            <div>&#160; &#160; &lt;h3 class="txt_bar"&gt;...&lt;/h3&gt;</div>
            <div>&#160; &lt;/div&gt;</div>
            <div>&lt;/div&gt;</div>
          </div>

        </div>
      </div>


      <div id="botones" class="patterns-section">
        <h2 class="patterns-section-title">Botones</h2>
        <p>Las clases de los botones <strong>pueden aplicarse también a la etiqueta &lt;a href="#"&gt;&lt;/a&gt;</strong>. Para <strong>cambiar su tamaño</strong> pueden aplicarse las clases .btn-sm y .btn-lg</p>
        <div class="patterns-subsection">
          <div class="d-flex gap-3">
            <button type="button" class="btn-orange">Orange</button>
            <button type="button" class="btn-black">Black</button>
            <button type="button" class="btn-grey">Grey</button>
            <button type="button" class="btn-transparent">Transparent</button>
          </div>

          <div class="patterns-code">
            <div>&lt;button type="button" class="btn-orange"&gt;Orange&lt;/button&gt;</div>
            <div>&lt;button type="button" class="btn-black"&gt;Black&lt;/button&gt;</div>
            <div>&lt;button type="button" class="btn-grey"&gt;Grey&lt;/button&gt;</div>
            <div>&lt;button type="button" class="btn-transparent"&gt;Transparent&lt;/button&gt;</div>
          </div>
        </div>
        <div class="patterns-subsection">
          <div class="d-flex gap-3">
            <button type="button" class="btn-orange-border">Orange Border</button>
            <button type="button" class="btn-black-border">Black Border</button>
            <button type="button" class="btn-light-border">Light Border</button>
          </div>

          <div class="patterns-code">
            <div>&lt;button type="button" class="btn-orange-border"&gt;Orange Border&lt;/button&gt;</div>
            <div>&lt;button type="button" class="btn-black-border"&gt;Black Border&lt;/button&gt;</div>
          </div>
        </div>
        <div class="patterns-subsection">
          <div class="d-flex gap-3">
            <button type="button" class="btn-back" href="#"><fa-icon [icon]="['fas','chevron-left']"></fa-icon> Voltar</button>
            <a href="#" class="btn-orange-border btn-icon">
              <div class="svg-icon"><svg viewBox="0 0 150 150">
                  <use xlink:href="assets/images/icons/ico_link_auto.svg#img" href="assets/images/icons/ico_link_auto.svg#img"></use>
                </svg></div> Aceder
            </a>
            <a href="#" class="btn-orange-border btn-icon btn-sq">
              <div class="svg-icon"><svg viewBox="0 0 150 150">
                  <use xlink:href="assets/images/icons/ico_link_auto.svg#img" href="assets/images/icons/ico_link_auto.svg#img"></use>
                </svg></div>
            </a>
            <div class="forum-like-buttons">
              <button type="button" class="no-likes-button" title="Like"><fa-icon [icon]="['fas','heart']"></fa-icon><span class="visually-hidden">Like</span></button>
            </div>
          </div>

          <div class="patterns-code">
            <div>&lt;button type="button" class="btn-back"&gt;&lt;fa-icon [icon]="['fas','chevron-left']"&gt;&lt;/fa-icon&gt; Voltar&lt;/button&gt;</div>
            <div>&lt;a href="#" class="btn-orange-border btn-icon"&gt;</div>
            <div>&#160; &#160; &lt;div class="svg-icon"&gt;&lt;svg viewBox="0 0 150 150"&gt;</div>
            <div>&#160; &#160; &#160; &#160; &#160; &#160; &lt;use xlink:href="assets/images/icons/ico_link_auto.svg#img" href="assets/images/icons/ico_link_auto.svg#img"&gt;&lt;/use&gt;</div>
            <div>&#160; &#160; &#160; &#160; &lt;/svg&gt;</div>
            <div>&#160; &#160; &lt;/div&gt;</div>
            <div>&#160; &#160; Aceder</div>
            <div>&lt;/a&gt;</div>
            <div>&lt;a href="#" class="btn-orange-border btn-icon btn-sq"&gt;</div>
            <div>&#160; &#160; &lt;div class="svg-icon"&gt;&lt;svg viewBox="0 0 150 150"&gt;</div>
            <div>&#160; &#160; &#160; &#160; &#160; &#160; &lt;use xlink:href="assets/images/icons/ico_link_auto.svg#img" href="assets/images/icons/ico_link_auto.svg#img"&gt;&lt;/use&gt;</div>
            <div>&#160; &#160; &#160; &#160; &lt;/svg&gt;</div>
            <div>&#160; &#160; &lt;/div&gt;</div>
            <div>&lt;/a&gt;</div>
            <div>&lt;div class="forum-like-buttons"&gt;</div>
            <div>&#160; &#160; &lt;button type="button" class="no-likes-button" title="Like"&gt;</div>
            <div>&#160; &#160; &#160; &#160; &lt;fa-icon [icon]="['fas','heart']"&gt;&lt;/fa-icon&gt;&lt;span class="visually-hidden"&gt;Like&lt;/span&gt;</div>
            <div>&#160; &#160; &lt;/button&gt;</div>
            <div>&lt;/div&gt;</div>
          </div>
        </div>
      </div>

      <div id="cards" class="patterns-section">
        <h2 class="patterns-section-title">Cards</h2>
        <div class="patterns-subsection">
          <h3>General cards</h3>
          <div class="document-card-row">
            <div class="col">
              <div class="card"><img onerror="this.src='assets/images/noImage.png'" alt="Dolorem dicta." src="assets/images/desarrollo/proyectos.png" class="card-img-top">
                <div class="card-body">
                  <div class="card-title">
                    <h4>Dolorem dicta.</h4>
                  </div>
                  <div class="card-text">Odit nostrum reprehenderit tenetur dolorem tenetur maiores autem quas.</div>
                </div>
                <div class="card-footer"><a href="#" class="btn-orange-border btn-icon stretched-link">
                    <div class="svg-icon"><svg viewBox="0 0 150 150">
                        <use xlink:href="assets/images/icons/ico_link_auto.svg#img" href="assets/images/icons/ico_link_auto.svg#img"></use>
                      </svg></div> Aceder
                  </a></div>
              </div>
            </div>
            <div class="col">
              <div class="card"><img onerror="this.src='assets/images/noImage.png'" alt="Consequuntur enim maxime." src="assets/images/desarrollo/proyectos.png" class="card-img-top">
                <div class="card-body">
                  <div class="card-title">
                    <h4>Consequuntur enim maxime.</h4>
                  </div>
                  <div class="card-text">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</div>
                </div>
                <div class="card-footer"><a href="#" class="btn-orange-border btn-icon stretched-link">
                    <div class="svg-icon"><svg viewBox="0 0 150 150">
                        <use xlink:href="assets/images/icons/ico_link_auto.svg#img" href="assets/images/icons/ico_link_auto.svg#img"></use>
                      </svg></div> Aceder
                  </a></div>
                <div class="ico-new"><img src="assets/images/icons/ico_New2.svg " title="Novo "></div>
              </div>
            </div>
            <div class="col">
              <div class="card"><img onerror="this.src='assets/images/noImage.png'" alt="Dolorem dicta." src="assets/images/desarrollo/proyectos.png" class="card-img-top">
                <div class="card-body">
                  <div class="card-title">
                    <h4>Dolorem dicta.</h4>
                  </div>
                  <div class="card-text">Odit nostrum reprehenderit tenetur dolorem tenetur maiores autem quas.</div>
                </div>
                <div class="card-footer"><a href="#" class="btn-orange-border btn-icon stretched-link">
                    <div class="svg-icon"><svg viewBox="0 0 150 150">
                        <use xlink:href="assets/images/icons/ico_link_auto.svg#img" href="assets/images/icons/ico_link_auto.svg#img"></use>
                      </svg></div> Aceder
                  </a></div>
              </div>
            </div>
            <div class="col">
              <div class="card"><img onerror="this.src='assets/images/noImage.png'" alt="Consequuntur enim maxime." src="assets/images/desarrollo/proyectos.png" class="card-img-top">
                <div class="card-body">
                  <div class="card-title">
                    <h4>Consequuntur enim maxime.</h4>
                  </div>
                  <div class="card-text">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</div>
                </div>
                <div class="card-footer"><a href="#" class="btn-orange-border btn-icon stretched-link">
                    <div class="svg-icon"><svg viewBox="0 0 150 150">
                        <use xlink:href="assets/images/icons/ico_link_auto.svg#img" href="assets/images/icons/ico_link_auto.svg#img"></use>
                      </svg></div> Aceder
                  </a></div>
                <div class="ico-new"><img src="assets/images/icons/ico_New2.svg " title="Novo "></div>
              </div>
            </div>
          </div>
        </div>

        <div class="patterns-code">
          <div>&lt;div class="document-card-row"&gt;</div>
          <div>&#160; &#160; &lt;div class="col"&gt;</div>
          <div>&#160; &#160; &#160; &#160; &lt;div class="card"&gt;&lt;img alt="..." src="..." class="card-img-top"&gt;</div>
          <div>&#160; &#160; &#160; &#160; &#160; &#160; &lt;div class="card-body"&gt;</div>
          <div>&#160; &#160; &#160; &#160; &#160; &#160; &#160; &#160; &lt;div class="card-title"&gt;</div>
          <div>&#160; &#160; &#160; &#160; &#160; &#160; &#160; &#160; &#160; &#160; &lt;h4&gt;...&lt;/h4&gt;</div>
          <div>&#160; &#160; &#160; &#160; &#160; &#160; &#160; &#160; &lt;/div&gt;</div>
          <div>&#160; &#160; &#160; &#160; &#160; &#160; &#160; &#160; &lt;div class="card-text"&gt;...&lt;/div&gt;</div>
          <div>&#160; &#160; &#160; &#160; &#160; &#160; &lt;/div&gt;</div>
          <div>&#160; &#160; &#160; &#160; &#160; &#160; &lt;div class="card-footer"&gt;&lt;a href="#" class="btn-orange-border btn-icon stretched-link"&gt;</div>
          <div>&#160; &#160; &#160; &#160; &#160; &#160; &#160; &#160; &#160; &#160; &lt;div class="svg-icon"&gt;&lt;svg viewBox="0 0 150 150"&gt;</div>
          <div>&#160; &#160; &#160; &#160; &#160; &#160; &#160; &#160; &#160; &#160; &#160; &#160; &#160; &#160; &lt;use xlink:href="assets/images/icons/ico_link_auto.svg#img" href="assets/images/icons/ico_link_auto.svg#img"&gt;&lt;/use&gt;</div>
          <div>&#160; &#160; &#160; &#160; &#160; &#160; &#160; &#160; &#160; &#160; &#160; &#160; &lt;/svg&gt;&lt;/div&gt; Orange</div>
          <div>&#160; &#160; &#160; &#160; &#160; &#160; &#160; &#160; &lt;/a&gt;&lt;/div&gt;</div>
          <div>&#160; &#160; &#160; &#160; &lt;/div&gt;</div>
          <div>&#160; &#160; &lt;/div&gt;</div>
          <div>&lt;/div&gt;</div>
        </div>
        <div class="patterns-subsection mt-4">
          <h3>Button cards orange</h3>
          <div class="card-button-row">
            <div class="col">
              <div class="card bg-orange">
                <div class="card-body">
                  <h4 class="txt_bar">Sección STIHL</h4>
                  <a href="#" class="stretched-link"><span class="visually-hidden">Aceder</span></a>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="card bg-orange">
                <div class="card-body">
                  <h4 class="txt_bar">Sección STIHL</h4>
                  <a href="#" class="stretched-link"><span class="visually-hidden">Aceder</span></a>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="card bg-orange">
                <div class="card-body">
                  <h4 class="txt_bar">Sección STIHL</h4>
                  <a href="#" class="stretched-link"><span class="visually-hidden">Aceder</span></a>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="card bg-orange">
                <div class="card-body">
                  <h4 class="txt_bar">Sección STIHL</h4>
                  <a href="#" class="stretched-link"><span class="visually-hidden">Aceder</span></a>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="card bg-orange">
                <div class="card-body">
                  <h4 class="txt_bar">Sección STIHL</h4>
                  <a href="#" class="stretched-link"><span class="visually-hidden">Aceder</span></a>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="card bg-orange">
                <div class="card-body">
                  <h4 class="txt_bar">Sección STIHL</h4>
                  <a href="#" class="stretched-link"><span class="visually-hidden">Aceder</span></a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="patterns-code">
          <div>&lt;div class="card-button-row"&gt;</div>
          <div>&#160; &lt;div class="col"&gt;</div>
          <div>&#160; &#160; &lt;div class="card bg-orange"&gt;</div>
          <div>&#160; &#160; &#160; &lt;div class="card-body"&gt;</div>
          <div>&#160; &#160; &#160; &#160; &lt;h4 class="txt_bar"&gt;Sección STIHL&lt;/h4&gt;</div>
          <div>&#160; &#160; &#160; &#160; &lt;a href="#" class="stretched-link"&gt;&lt;span class="visually-hidden"&gt;Aceder&lt;/span&gt;&lt;/a&gt;</div>
          <div>&#160; &#160; &#160; &lt;/div&gt;</div>
          <div>&#160; &#160; &lt;/div&gt;</div>
          <div>&#160; &lt;/div&gt;</div>
          <div>&#160; ...</div>
          <div>&lt;/div&gt;</div>
        </div>
        <div class="patterns-subsection mt-4">
          <h3>Button cards image</h3>
          <div class="card-button-row image-button-row">
            <div class="col">
              <div class="card bg-orange" style="background-image: url('assets/develop/images/image.jpg');">
                <div class="card-body">
                  <h3 class="txt_bar">Sección STIHL</h3>
                  <a href="#" class="stretched-link"><span class="visually-hidden">Aceder</span></a>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="card bg-orange" style="background-image: url('assets/develop/images/image.jpg');">
                <div class="card-body">
                  <h3 class="txt_bar">Sección STIHL</h3>
                  <a href="#" class="stretched-link"><span class="visually-hidden">Aceder</span></a>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="card bg-orange disabled" style="background-image: url('assets/develop/images/image.jpg');">
                <div class="card-body">
                  <h3 class="txt_bar">Link deshabilitado</h3>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="patterns-code">
          <div>&lt;div class="card-button-row image-button-row"&gt;</div>
          <div>&#160; &lt;div class="col"&gt;</div>
          <div>&#160; &#160; &lt;div class="card bg-orange" style="background-image: url('...');"&gt;</div>
          <div>&#160; &#160; &#160; &lt;div class="card-body"&gt;</div>
          <div>&#160; &#160; &#160; &#160; &lt;h4 class="txt_bar"&gt;Sección STIHL&lt;/h4&gt;</div>
          <div>&#160; &#160; &#160; &#160; &lt;a href="#" class="stretched-link"&gt;&lt;span class="visually-hidden"&gt;Aceder&lt;/span&gt;&lt;/a&gt;</div>
          <div>&#160; &#160; &#160; &lt;/div&gt;</div>
          <div>&#160; &#160; &lt;/div&gt;</div>
          <div>&#160; &lt;/div&gt;</div>
          <div>&#160; &lt;div class="col"&gt;</div>
          <div>&#160; &#160; &lt;div class="card bg-orange disabled" style="background-image: url('...');"&gt;</div>
          <div>&#160; &#160; &#160; &lt;div class="card-body"&gt;</div>
          <div>&#160; &#160; &#160; &#160; &lt;h4 class="txt_bar"&gt;Link deshabilitado&lt;/h4&gt;</div>
          <div>&#160; &#160; &#160; &lt;/div&gt;</div>
          <div>&#160; &#160; &lt;/div&gt;</div>
          <div>&#160; &lt;/div&gt;</div>
          <div>&#160; ...</div>
          <div>&lt;/div&gt;</div>
        </div>
      </div>

      <div id="carrusel" class="patterns-section">
        <h2 class="patterns-section-title">Carrusel</h2>
        <div class="patterns-subsection">
          <div id="carouselStihl" data-bs-ride="carousel" data-bs-interval="7000" data-bs-pause="hover" class="carousel carousel-2-cols slide">
            <div class="carousel-inner">
              <div class="carousel-item active">
                <div class="carousel-inner-container">
                  <div class="carousel-img-container">
                    <img alt="Alt..." class="carousel-img" src="https://placehold.co/1495x699/f1792c/FFF?text=Slide+1">
                  </div>
                  <div class="carousel-content">
                    <div class="carrusel-title">
                      Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                    </div>
                    <div class="carrusel-description">
                      Lorem ipsum dolor sit amet, consectetur adipisicing elit. Consequuntur, reprehenderit eius, omnis in ad quasi dignissimos aperiam et, voluptatum provident tempore consectetur!
                    </div>
                    <div class="carrusel-cta"><a class="btn-black-border" href="#" target="" title="DESCARGAR MATERIALES">Lorem ipsum</a>
                    </div>
                  </div>
                </div>
              </div>

              <div class="carousel-item">
                <div class="carousel-inner-container">
                  <div class="carousel-img-container">
                    <img alt="Alt..." class="carousel-img" src="https://placehold.co/1495x699/f1792c/FFF?text=Slide+2">
                  </div>
                  <div class="carousel-content">
                    <div class="carrusel-title">
                      Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                    </div>
                    <div class="carrusel-description">
                      Lorem ipsum dolor sit amet, consectetur adipisicing elit. Consequuntur, reprehenderit eius, omnis in ad quasi dignissimos aperiam et, voluptatum provident tempore consectetur!
                    </div>
                    <div class="carrusel-cta"><a class="btn-black-border" href="#" target="" title="DESCARGAR MATERIALES">Lorem ipsum</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <button class="carousel-control-prev" type="button" data-bs-target="#carouselStihl" data-bs-slide="prev">
              <span class="carousel-control-prev-icon" aria-hidden="true"></span>
              <span class="visually-hidden">Anterior</span>
            </button>
            <button class="carousel-control-next" type="button" data-bs-target="#carouselStihl" data-bs-slide="next">
              <span class="carousel-control-next-icon" aria-hidden="true"></span>
              <span class="visually-hidden">Seguinte</span>
            </button>
          </div>

          <div class="patterns-code">
            <div> &lt;div id="carouselStihl" data-bs-ride="carousel" data-bs-interval="7000" data-bs-pause="hover" class="carousel carousel-2-cols slide"&gt;</div>
            <div>&#160; &lt;div class="carousel-inner"&gt;</div>
            <div>&#160; &#160; &lt;div class="carousel-item active"&gt;</div>
            <div>&#160; &#160; &#160; &lt;div class="carousel-inner-container"&gt;</div>
            <div>&#160; &#160; &#160; &#160; &lt;div class="carousel-img-container"&gt;</div>
            <div>&#160; &#160; &#160; &#160; &#160; &lt;img alt="Alt..." class="carousel-img" src="..."&gt;</div>
            <div>&#160; &#160; &#160; &#160; &lt;/div&gt;</div>
            <div>&#160; &#160; &#160; &#160; &lt;div class="carousel-content"&gt;</div>
            <div>&#160; &#160; &#160; &#160; &#160; &lt;div class="carrusel-title"&gt;</div>
            <div>&#160; &#160; &#160; &#160; &#160; &#160; Lorem ipsum, dolor sit amet consectetur adipisicing elit.</div>
            <div>&#160; &#160; &#160; &#160; &#160; &lt;/div&gt;</div>
            <div>&#160; &#160; &#160; &#160; &#160; &lt;div class="carrusel-description"&gt;</div>
            <div>&#160; &#160; &#160; &#160; &#160; &#160; Consequuntur, reprehenderit eius, omnis in ad quasi dignissimos aperiam et, voluptatum provident tempore consectetur!</div>
            <div>&#160; &#160; &#160; &#160; &#160; &lt;/div&gt;</div>
            <div>&#160; &#160; &#160; &#160; &#160; &lt;div class="carrusel-cta"&gt;&lt;a class="btn-black-border" href="#" target="" title="..."&gt;Lorem ipsum&lt;/a&gt;</div>
            <div>&#160; &#160; &#160; &#160; &#160; &lt;/div&gt;</div>
            <div>&#160; &#160; &#160; &#160; &lt;/div&gt;</div>
            <div>&#160; &#160; &#160; &lt;/div&gt;</div>
            <div>&#160; &#160; &lt;/div&gt;</div>
            <br>
            <div>&#160; &#160; &lt;div class="carousel-item"&gt;</div>
            <div>&#160; &#160; &#160; &lt;div class="carousel-inner-container"&gt;</div>
            <div>&#160; &#160; &#160; &#160; &lt;div class="carousel-img-container"&gt;</div>
            <div>&#160; &#160; &#160; &#160; &#160; &lt;img alt="Alt..." class="carousel-img" src="..."&gt;</div>
            <div>&#160; &#160; &#160; &#160; &lt;/div&gt;</div>
            <div>&#160; &#160; &#160; &#160; &lt;div class="carousel-content"&gt;</div>
            <div>&#160; &#160; &#160; &#160; &#160; &lt;div class="carrusel-title"&gt;</div>
            <div>&#160; &#160; &#160; &#160; &#160; &#160; Lorem ipsum, dolor sit amet consectetur adipisicing elit.</div>
            <div>&#160; &#160; &#160; &#160; &#160; &lt;/div&gt;</div>
            <div>&#160; &#160; &#160; &#160; &#160; &lt;div class="carrusel-description"&gt;</div>
            <div>&#160; &#160; &#160; &#160; &#160; &#160; Consequuntur, reprehenderit eius, omnis in ad quasi dignissimos aperiam et, voluptatum provident tempore consectetur!</div>
            <div>&#160; &#160; &#160; &#160; &#160; &lt;/div&gt;</div>
            <div>&#160; &#160; &#160; &#160; &#160; &lt;div class="carrusel-cta"&gt;&lt;a class="btn-black-border" href="#" target="" title="..."&gt;Lorem ipsum&lt;/a&gt;</div>
            <div>&#160; &#160; &#160; &#160; &#160; &lt;/div&gt;</div>
            <div>&#160; &#160; &#160; &#160; &lt;/div&gt;</div>
            <div>&#160; &#160; &#160; &lt;/div&gt;</div>
            <div>&#160; &#160; &lt;/div&gt;</div>
            <div>&#160; &lt;/div&gt;</div>
            <br>
            <div>&#160; &lt;button class="carousel-control-prev" type="button" data-bs-target="#carouselStihl" data-bs-slide="prev"&gt;</div>
            <div>&#160; &#160; &lt;span class="carousel-control-prev-icon" aria-hidden="true"&gt;&lt;/span&gt;</div>
            <div>&#160; &#160; &lt;span class="visually-hidden"&gt;Anterior&lt;/span&gt;</div>
            <div>&#160; &lt;/button&gt;</div>
            <div>&#160; &lt;button class="carousel-control-next" type="button" data-bs-target="#carouselStihl" data-bs-slide="next"&gt;</div>
            <div>&#160; &#160; &lt;span class="carousel-control-next-icon" aria-hidden="true"&gt;&lt;/span&gt;</div>
            <div>&#160; &#160; &lt;span class="visually-hidden"&gt;Seguinte&lt;/span&gt;</div>
            <div>&#160; &lt;/button&gt;</div>
            <div> &lt;/div&gt;</div>
          </div>
        </div>
      </div>

      <div id="accordion" class="patterns-section">
        <h2 class="patterns-section-title">Accordion</h2>
        <div class="patterns-subsection">
          <div id="idAccordion" class="accordion accordion-flush">
            <div class="accordion-item">
              <h2 class="accordion-header" id="head0"><button type="button" data-bs-toggle="collapse" aria-expanded="false" class="accordion-button collapsed" data-bs-target="#accordion0"> Minima explicabo nihil exercitationem esse illo ullam. </button></h2>
              <div data-bs-parent="#idAccordion" class="accordion-collapse collapse" id="accordion0">
                <div class="accordion-body">Magnam iure error enim nostrum eius impedit veniam blanditiis itaque. Temporibus accusamus consectetur sunt veritatis minus pariatur laudantium molestias. Nisi hic quo rem. Magnam iure error enim nostrum eius impedit veniam blanditiis itaque. Temporibus accusamus consectetur sunt veritatis minus pariatur laudantium molestias. Nisi hic quo rem. Magnam iure error enim nostrum eius impedit veniam blanditiis itaque. Temporibus accusamus consectetur sunt veritatis minus pariatur laudantium molestias. Nisi hic quo rem.</div>
              </div>
            </div>
            <div class="accordion-item">
              <h2 class="accordion-header" id="head1"><button type="button" data-bs-toggle="collapse" aria-expanded="false" class="accordion-button collapsed" data-bs-target="#accordion1"> Sed tempore autem numquam consequatur quisquam amet cupiditate esse est. </button></h2>
              <div data-bs-parent="#idAccordion" class="accordion-collapse collapse" id="accordion1">
                <div class="accordion-body">Corporis distinctio cumque voluptatum harum architecto commodi. Reiciendis aut debitis corrupti dignissimos ipsam. Temporibus est cupiditate magnam suscipit repellendus voluptas quidem numquam natus.
                  Veritatis consequatur excepturi nemo eius. Voluptate fugiat neque praesentium explicabo ullam aliquam reprehenderit exercitationem. Expedita nam officiis sit consequuntur.
                  Quasi quia laborum eaque ullam et. Impedit laborum non sapiente saepe. Nihil iure numquam.</div>
              </div>
            </div>
            <div class="accordion-item">
              <h2 class="accordion-header" id="head2"><button type="button" data-bs-toggle="collapse" aria-expanded="false" class="accordion-button collapsed" data-bs-target="#accordion2"> Adipisci excepturi dolore nihil ipsam vero. </button></h2>
              <div data-bs-parent="#idAccordion" class="accordion-collapse collapse" id="accordion2">
                <div class="accordion-body">Dolorem inventore cum. Aspernatur voluptate voluptatem dolore consectetur. Quae praesentium a dignissimos repudiandae est impedit nobis.
                  Sint modi quidem. Perferendis reiciendis fuga veritatis quas iusto qui error porro quas. Possimus consequuntur labore eos quae.
                  Earum dolores atque. Aperiam quod voluptatem nihil tempora atque unde. Officia saepe laboriosam enim praesentium facere qui explicabo aliquam.</div>
              </div>
            </div>
            <div class="accordion-item">
              <h2 class="accordion-header" id="head3"><button type="button" data-bs-toggle="collapse" aria-expanded="false" class="accordion-button collapsed" data-bs-target="#accordion3"> Excepturi quas nostrum doloribus asperiores id quod sed possimus quam. In illo non facilis libero temporibus similique. Consequatur assumenda officiis ab vero ducimus voluptas recusandae illo explicabo. </button></h2>
              <div data-bs-parent="#idAccordion" class="accordion-collapse collapse" id="accordion3">
                <div class="accordion-body">Quas repellendus consequuntur minima. Magnam sed officiis. Enim quidem libero ut distinctio sapiente natus nobis.
                  Perspiciatis est doloribus consectetur repudiandae. Error porro impedit delectus repellendus cum ex eaque fugiat dolores. Sed inventore autem ad omnis id architecto sunt corporis animi.
                  Soluta perspiciatis earum voluptatem voluptates. Deserunt commodi incidunt sit aperiam aspernatur nostrum ducimus accusantium reiciendis. In in hic hic eaque eaque natus eveniet eaque doloribus.</div>
              </div>
            </div>
          </div>

          <div class="patterns-code">
            <div>&lt;div id="idAccordion" class="accordion accordion-flush"&gt;</div>
            <div>&#160; &lt;div class="accordion-item"&gt;</div>
            <div>&#160; &#160; &lt;h2 class="accordion-header" id="head0"&gt;</div>
            <div>&#160; &#160; &#160; &lt;button type="button" data-bs-toggle="collapse" aria-expanded="false" class="accordion-button collapsed" data-bs-target="#accordion0"&gt;Minima explicabo nihil exercitationem esse illo ullam.&lt;/button&gt;</div>
            <div>&#160; &#160; &lt;/h2&gt;</div>
            <div>&#160; &#160; &lt;div data-bs-parent="#idAccordion" class="accordion-collapse collapse" id="accordion0"&gt;</div>
            <div>&#160; &#160; &#160; &lt;div class="accordion-body"&gt;Magnam iure error enim nostrum eius impedit veniam blanditiis itaque...&lt;/div&gt;</div>
            <div>&#160; &#160; &lt;/div&gt;</div>
            <div>&#160; &lt;/div&gt;</div>
            <div>&#160; &lt;div class="accordion-item"&gt;</div>
            <div>&#160; &#160; &lt;h2 class="accordion-header" id="head1"&gt;</div>
            <div>&#160; &#160; &#160; &lt;button type="button" data-bs-toggle="collapse" aria-expanded="false" class="accordion-button collapsed" data-bs-target="#accordion1"&gt;Minima explicabo nihil exercitationem esse illo ullam.&lt;/button&gt;</div>
            <div>&#160; &#160; &lt;/h2&gt;</div>
            <div>&#160; &#160; &lt;div data-bs-parent="#idAccordion" class="accordion-collapse collapse" id="accordion1"&gt;</div>
            <div>&#160; &#160; &#160; &lt;div class="accordion-body"&gt;Magnam iure error enim nostrum eius impedit veniam blanditiis itaque...&lt;/div&gt;</div>
            <div>&#160; &#160; &lt;/div&gt;</div>
            <div>&#160; &lt;/div&gt;</div>
            <div>&lt;/div&gt;</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>